import React, { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../../Utils/responsive';
import PaymentStatusWeb from './web';
import PaymentStatusMob from './mob';

const PaymentStatus = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? <PaymentStatusMob /> : <PaymentStatusWeb />;
};

export default PaymentStatus;
